import { render, staticRenderFns } from "./teamList.vue?vue&type=template&id=40bc786f&scoped=true"
import script from "./teamList.vue?vue&type=script&lang=js"
export * from "./teamList.vue?vue&type=script&lang=js"
import style0 from "./teamList.vue?vue&type=style&index=0&id=40bc786f&prod&scoped=true&lang=css"
import style1 from "./teamList.vue?vue&type=style&index=1&id=40bc786f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bc786f",
  null
  
)

export default component.exports